import React from 'react';
import { Container, Row, Col } from 'react-bootstrap'; // Added Row and Col imports
import { Link } from 'react-router-dom';
import Slider from  '../components/Slider';
import AboutSection from '../components/AboutSection';
import FeaturedEvents from '../components/FeaturedEvents';

function Home() {
  return (
    <div>
      <Slider />
      <FeaturedEvents />
      <Container className="py-5">
      
        <AboutSection />

        <Row className="mb-5">
          <Col md={4} className="mb-4">
            <div className="text-center p-4 bg-light rounded">
              <i className="fas fa-cogs fa-3x mb-3"></i>
              <h4>Pourquoi DeltaX ?</h4>
              <p>Aventure et découvertes : Offrir des expériences authentiques dans des environnements naturels spectaculaires. Professionnalisme et sécurité : Collaborer uniquement avec des professionnels qualifiés et expérimentés pour assurer la sécurité des participants. Accessibilité et simplicité : Rendre l'aventure accessible à tous grâce à une plateforme facile à utiliser et des informations claires.</p>
            </div>
          </Col>
          <Col md={4} className="mb-4">
            <div className="text-center p-4 bg-light rounded">
              <i className="fas fa-users fa-3x mb-3"></i>
              <h4>Notre Mission</h4>
              <p>Nous avons pour mission de connecter les voyageurs à des experts locaux dans le domaine du tourisme d'aventure. Grâce à notre plateforme en ligne, nous permettons à chacun de découvrir et de réserver facilement des activités adaptées à ses envies et à son niveau. 
                Nous mettons en avant des prestataires de confiance, allant des guides spécialisés aux opérateurs d'activités, afin de garantir une expérience immersive et sécurisée.</p>
            </div>
          </Col>
          <Col md={4} className="mb-4">
            <div className="text-center p-4 bg-light rounded">
              <i className="fas fa-chart-line fa-3x mb-3"></i>
              <h4>Nos Services</h4>
              <p>DeltaX permet aux utilisateurs de : Explorer une large gamme d'activités d'aventure : Des sports extrêmes aux activités plus tranquilles en pleine nature, il y en a pour tous les goûts. Réserver en ligne : Une plateforme pratique et intuitive pour réserver en quelques clics. Découvrir des professionnels locaux : Des guides, instructeurs et opérateurs touristiques qui partagent leur expertise et leur passion pour l'aventure.</p>
            </div>
          </Col>
        </Row>
        
      </Container>
      
     
    </div>
  );
}

export default Home;